import { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import { FaBars } from 'react-icons/fa';
import { APP_IMG } from 'src/constants';
import styled from 'styled-components';

const HeaderBCHTalk = () => {
  const dataNav = [
    { id: 1, name: 'HOME', link: '#HOME' },
    { id: 2, name: 'AGENDA', link: '#AGENDA' },
    { id: 3, name: 'SPEAKERS', link: '#SPEAKERS' },
    { id: 4, name: 'SESSIONS', link: '#SESSIONS' },
    { id: 5, name: 'ABOUT US', link: '#ABOUT_US' }
  ];

  const [toggle, setToggle] = useState(false);

  return (
    <HeaderWrapper>
      <nav>
        <img
          src={`${APP_IMG}/images/bcgtalk/logo-isab-bcg.webp`}
          alt='logo-header'
          width={200}
          height='100%'
        />
        <ul>
          {dataNav.map((item, index) => (
            <li key={index}>
              <a href={item.link}>
                <p>{item.name}</p>
              </a>
            </li>
          ))}
        </ul>
        <div className='nav-mobile'>
          {toggle && (
            <div className='mobile-list'>
              <div className='bar-close'>
                <CgClose
                  size={30}
                  onClick={() => {
                    setToggle(!toggle);
                  }}
                />
              </div>
              {dataNav.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setToggle(!toggle);
                  }}>
                  <a href={item.link}>
                    <p>{item.name}</p>
                  </a>
                </div>
              ))}
            </div>
          )}
          <FaBars
            size={30}
            onClick={() => {
              setToggle(!toggle);
            }}
          />
        </div>
      </nav>
    </HeaderWrapper>
  );
};

export default HeaderBCHTalk;

const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
  img {
    width: 120px;
    @media (max-width: 768px) {
      width: 100px;
    }
  }
  nav {
    width: 1200px;
    max-width: 100%;
    margin: auto;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    svg {
      @media (min-width: 769px) {
        display: none;
      }
    }
    ul {
      display: flex;
      list-style-type: none;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        display: none;
      }
      li {
        padding: 5px 10px;
        a {
          p {
            font-size: 24px;
            font-weight: 600;
            @media (max-width: 1024px) {
              font-size: 22px;
            }
            @media (max-width: 768px) {
              font-size: 20px;
            }
          }
        }
      }
    }
    .nav-mobile {
      @media (min-width: 769px) {
        display: none;
      }
      .mobile-list {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100vh;
        background-color: #fff;
        z-index: 1;
        padding: 30px;
        .bar-close {
          text-align: end;
        }
        a {
          p {
            margin: auto;
            border-bottom: 1px solid #3d3d3d;
            max-width: max-content;
            font-size: 20px;
            padding: 15px;
          }
        }
      }
    }
  }
`;
